import { TrailDisplayComponent } from "ags/components/trail-display";
import { PretellResult } from "ags/integration/model/results/pretell-result";
import { AgsSparkSpin } from "ags/state-machine/states/ags-spark-spin";
import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { ThemeSparkBehaviour } from "behaviours/theme-spark-behaviour";
import { gameLayers } from "game-layers";
import { SymbolSubcomponent } from "slotworks/components/matrix/symbol/symbol-subcomponent";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

const pretellAnimations = [
    "pretell_stampede", // removed, won't be used
    "pretell_bouncy", // removed, won't be used
    "pretell_rolling_stampede"
];

export class ThemeSparkSpin extends AgsSparkSpin {
    protected pretellVisible: boolean;
    protected skipQueued: boolean;

    public onEnter() {
        this.pretellVisible = false;
        this.skipQueued = false;

        this.showPretell().then(() => {
            super.onEnter();
            if (this.skipQueued) { this.onSkip(); }
        });
    }

    public onSkip() {
        if (this.pretellVisible) {
            this.skipQueued = true;
            uiFlags.set(UIFlag.NO_SKIP, true);
        } else {
            super.onSkip();
        }
    }

    public onExit() {
        Services.get(SoundService).customEvent(`reel_spin_stop`);
        super.onExit();
    }

    protected showPretell(): Contract<void> {
        const record = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;
        const pretellResult = record.getFirstResultOfType(PretellResult);
        if (!pretellResult) { return Contract.empty(); }

        // We removed all but one of the pretells for space/quality reasons, so we just have to override pretellResult.animationType
        const animName = pretellAnimations[2];
        const anim = gameLayers.MatrixForeground.getAnimatedSprite(animName);

        gameLayers.MatrixForeground.add(anim); // bring to front

        return new Sequence([
            () => Contract.wrap(() => {
                Services.get(SoundService).customEvent(animName);
                anim.visible = true;
                this.pretellVisible = true;
            }),
            () => anim.gotoAndPlayOnce(0),
            () => Contract.wrap(() => {
                anim.visible = false;
                this.pretellVisible = false;
            })
        ]);
    }

    protected createWildBehaviour(symbol: SymbolSubcomponent, upgradeLevel: number) {
        return new ThemeSparkBehaviour(symbol, upgradeLevel, new TrailDisplayComponent());
    }
}
